<app-header></app-header>
<div id="main-content">
    <div class="content" role="main">
        <div class="content-margin">
            <div class="col-xl-12 col-lg-11 col-md-11 col-sm-11 mx-auto">
                <h2 attr.aria-label="{{ 'pagenotfound.title' | translate }}">
                    {{ 'pagenotfound.title' | translate }}</h2>
                <p class="mt-4" attr.aria-label="{{ 'pagenotfound.massage' | translate }}">
                    {{ 'pagenotfound.massage' | translate }}
                </p>
                <p attr.aria-label="{{ 'pagenotfound.fromhere' | translate }}">{{ 'pagenotfound.fromhere' | translate }}
                </p>
                <ul class="pl-3">
                    <li attr.aria-label="{{ 'pagenotfound.goback' | translate }}">
                        <a
                            href="{{ 'pagenotfound.gobacklink' | translate }}">{{ 'pagenotfound.goback' | translate }}</a>
                    </li>
                    <li attr.aria-label="{{ 'pagenotfound.search' | translate }}">
                        {{ 'pagenotfound.search' | translate }}
                    </li>
                    <li
                        attr.aria-label="{{ 'pagenotfound.contactus' | translate }} {{ 'pagenotfound.question' | translate }}">
                        <a
                            href="{{ 'pagenotfound.contactuslink' | translate }}">{{ 'pagenotfound.contactus' | translate }}</a>
                        {{ 'pagenotfound.question' | translate }}
                    </li>
                </ul>
                <span class="info"
                    attr.aria-label="{{ 'pagenotfound.phone' | translate }}">{{ 'pagenotfound.phone' | translate }}</span>
                <p  attr.aria-label="{{ 'pagenotfound.number' | translate }}">{{ 'pagenotfound.number' | translate }}</p>
            </div>
        </div>
    </div>
</div>